export default (constructablePath: string) => constructablePath.replace(/\{api}/, import.meta.env.VITE_API_PATH)